import { CategoriesTab } from 'stores/categories/types';

export const categoryTabs: CategoriesTab[] = ['basic', 'translations'];

export const productCategoryTabs: CategoriesTab[] = ['basic', 'translations', 'keywords'];
